import React from 'react'
import PropTypes from 'prop-types'
import { FormGroup, Input, Label } from 'reactstrap'

const UserInfosInput = ({ id, label, onChange, value, type, required }) => (
  <FormGroup className="text-input">
    <Input
      className={value === '' ? '' : 'has-value'}
      id={id}
      defaultValue={value}
      onChange={onChange}
      required={required}
      type={type}
    />
    <Label for={id}>
      {label}
      {required ? '*' : ''}
    </Label>
  </FormGroup>
)

UserInfosInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
}

export default UserInfosInput
